import {default as Validator} from './vendor/validator/index';
import {Base} from "./base";

export class Phone extends Base {
    constructor(element, locale = 'ru-RU', strictMode = false) {
        super(element);
        this.locale = locale;
        this.strictMode = strictMode;
        this.validator = Validator.isMobilePhone;
        this.preprocessor = this.preparePhone;
    }
    isValid() {
        return super.isValid([
            this.locale,
            {strictMode: this.strictMode}
        ]);
    }
    preparePhone(value) {
        return MB.Validator.Fn.blacklist(value, ['(',')', ' ', '-'])
    }
}
